module.exports = __webpack_public_path__ + "img/block-3.a1ac0dfa.png";